import Swiper, { Autoplay } from "swiper";

export default () => ({
  swiper: null,
  pauseOnHover: true,

  init() {
    // Only initialize slider if there are multiple announcements
    if (this.$refs.slider) {
      this.initSlider();
    }
  },

  initSlider() {
    try {
      this.swiper = new Swiper(this.$refs.slider, {
        direction: "vertical",
        loop: true,
        modules: [Autoplay],
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: this.pauseOnHover,
        },
        speed: 800,
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false,
        grabCursor: false,
        watchOverflow: true,
        on: {
          init: function () {
            this.el.style.height = "100%";
          },
          slideChange: function () {},
        },
      });
    } catch (error) {
      console.error("Error creating Swiper:", error);
    }
  },
});
